import { _ as t } from "../internals/export.js";
import { g as n } from "../internals/get-built-in.js";
import { f as r } from "../internals/function-apply.js";
import { f as e } from "../internals/function-bind.js";
import { a as s } from "../internals/a-constructor.js";
import { a as o } from "../internals/an-object.js";
import { i as a } from "../internals/is-object.js";
import { o as i } from "../internals/object-create.js";
import { f as c } from "../internals/fails.js";
var f = n("Reflect", "construct"),
  u = Object.prototype,
  m = [].push,
  l = c(function () {
    function t() {}
    return !(f(function () {}, [], t) instanceof t);
  }),
  p = !c(function () {
    f(function () {});
  }),
  j = l || p;
t({
  target: "Reflect",
  stat: !0,
  forced: j,
  sham: j
}, {
  construct: function construct(t, n) {
    s(t), o(n);
    var c = arguments.length < 3 ? t : s(arguments[2]);
    if (p && !l) return f(t, n, c);
    if (t == c) {
      switch (n.length) {
        case 0:
          return new t();
        case 1:
          return new t(n[0]);
        case 2:
          return new t(n[0], n[1]);
        case 3:
          return new t(n[0], n[1], n[2]);
        case 4:
          return new t(n[0], n[1], n[2], n[3]);
      }
      var j = [null];
      return r(m, j, n), new (r(e, t, j))();
    }
    var w = c.prototype,
      b = i(a(w) ? w : u),
      g = r(t, b, n);
    return a(g) ? g : b;
  }
});